module.exports = "/img/_/_/_/assets/images/creeper/book/common//34.jpg?be6f4b2592ea471345cc5aa3de34bc58";